import { Category, DiscoverySearchType } from 'src/components/Discovery/index.type';
import { discoveryReportsData } from 'src/data/discoveryReportsData';
import { IoClose } from 'react-icons/io5';
import { ReportType } from 'src/components/ReportTableManage/index.type';
import { useClickAway } from '@uidotdev/usehooks';
import { useTranslation } from 'react-i18next';
import Button from 'src/components/input/Button';
import DiscoveryAccordion from 'src/components/Discovery/DiscoveryAccordion';
import DiscoverySearch from 'src/components/Discovery/DiscoverySearch';
import RadioButtons from 'src/components/FilterSections/RadioButtons';
import React, { useEffect, useState } from 'react'
import TextInputWithSearchIcon from 'src/components/input/TextInputWithSearchIcon';
import useCallApi from 'src/hooks/useCallApi';
import { BarLoader } from 'src/components/Loader';

const DiscoveryReports = ({ setHeaderTitle }: any) => {
    const { t } = useTranslation();
    const [showResults, setShowResults] = useState(false);
    const [searchInputValue, setSearchInputValue] = useState('')
    const [searchQuery, setSearchQuery] = useState('')
    const [filteredData, setFilteredData] = useState<Category[]>([])
    const [allData, setAllData] = useState<Category[]>([])
    const [expandedCategoryId, setExpandedCategoryId] = useState<string | null>(null)
    const [selectedFilter, setSelectedFilter] = useState({ id: "1", name: t("discoveryReports.reportName") })
    const { callApi, callApiLoading } = useCallApi();
    const ref: any = useClickAway(() => { setShowResults(false) });

    // For now, we'll use the static data. Later this can be replaced with filtered/searched data
    const displayData = discoveryReportsData

    const OPTIONS_PERMISSION = [
        { name: t("discoveryReports.reportName"), id: DiscoverySearchType.Report },
        { name: t("discoveryReports.category"), id: DiscoverySearchType.Category },
    ]

    //to handle the search input change
    const handleSearch = async (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchInputValue(e.target.value)
        setSearchQuery(e.target.value)
        setShowResults(true)
        if (e.target.value === "") {
            handleReset();
        }
    }

    const handleSelect = (item: { id: string, name: string }) => {
        setSearchInputValue(item.name)
        setSearchQuery("")
        setShowResults(false)
        if (selectedFilter.id === DiscoverySearchType.Category) {
            const filteredCategories = allData.filter((category: Category) => category.id === item.id)
            setFilteredData(filteredCategories)
            setExpandedCategoryId(item.id)
        } else {
            let categoryFound: Category[] = allData.filter((category: Category) => category.reports.some((report: ReportType) => report.id === item.id))
            if (categoryFound.length > 0) {
                const reportFound = categoryFound[0].reports.filter((report: ReportType) => report.id === item.id)
                const categoryWithFilteredReports = {
                    ...categoryFound[0],
                    reports: reportFound
                }
                setFilteredData([categoryWithFilteredReports])
                setExpandedCategoryId(categoryFound[0].id)
            }
        }
    }

    const handleReset = () => {
        setSearchInputValue("")
        setSearchQuery("")
        setShowResults(false)
        setFilteredData(allData)
        setExpandedCategoryId(null)
    }

    const fetchItemList = async () => {
        let res = await callApi({ endpoint: "GlobalSearchReport", query: "" });
        setAllData(res || []);
        setFilteredData(res || []);
    }

    useEffect(() => { fetchItemList() }, [])

    useEffect(() => { setHeaderTitle(t("discoveryReports.title")) }, [t])

    return (
        <main className="flex w-full pt-7">
            <div className='w-full px-11'>
                <header className='flex justify-between items-center mb-6 relative'>
                    <section className="flex sm:flex-col md:flex-row items-center gap-5 justify-start ">
                        <RadioButtons options={OPTIONS_PERMISSION} radioButtonHandler={(e: any) => setSelectedFilter(e)} title='' value={selectedFilter.id} />
                        <div className='px-1 py-4 relative' ref={ref}>
                            <div className='flex min-w-[400px] relative' >
                                <TextInputWithSearchIcon handleChange={handleSearch} placeholder={t('discoveryReports.searchByCategoryOrReportName')} value={searchInputValue} border_radio={false} />
                                <aside>
                                    {searchInputValue.length > 0 &&
                                        <Button btnType="main" className="absolute right-2 top-[13px] rounded-full" icon={<IoClose size={12} />} handleClick={handleReset} />
                                    }
                                </aside>
                            </div>
                            {showResults && <DiscoverySearch searchQuery={searchQuery} handleSelect={handleSelect} selectedFilter={selectedFilter.id} allData={allData} />}
                        </div>
                    </section>
                </header>
                {
                    callApiLoading
                        ? <BarLoader />
                        : <DiscoveryAccordion list={filteredData} expandedCategoryId={expandedCategoryId} />
                }
            </div>
        </main>
    )
}

export default DiscoveryReports